import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Paper, Typography, Snackbar, Divider } from '@mui/material';
import NoData from '../../_common/NoData';
import { dataConstants } from '../../../constants';
import dynamic from 'next/dynamic';
import LoadingItem from '../../_common/Skeleton/stock';
import Grid from '@mui/material/Grid';

// import RealGDP from './RealGDP';
// import RealGDPGrowth from './RealGDPGrowth';
// import IndustrialProduction from './IndustrialProduction';
// import CurrentInflationMeasures from './CurrentInflationMeasures';
// import HistoricalConsumerPrice from './HistoricalConsumerPrice';
// import CPIvPCE from './CPIvPCE';
// import Consumption from './Consumption';
// import NonFarmPayroll from './NonFarmPayroll';
// import LaborForceParticipation from './LaborForceParticipation';
// import UnemploymentRate from './UnemploymentRate';
// import RetailSales from './RetailSales';
// import SavingsTrend from './SavingsTrend';

// const RealGDP = dynamic(() => import('./RealGDP'),
//   { loading: () => <LoadingItem /> })
// const RealGDPGrowth = dynamic(() => import('./RealGDPGrowth'),
//   { loading: () => <LoadingItem /> })
// const IndustrialProduction = dynamic(() => import('./IndustrialProduction'),
//   { loading: () => <LoadingItem /> })
// const CurrentInflationMeasures = dynamic(() => import('./CurrentInflationMeasures'),
//   { loading: () => <LoadingItem /> })
// const HistoricalConsumerPrice = dynamic(() => import('./HistoricalConsumerPrice'),
//   { loading: () => <LoadingItem /> })
// const CPIvPCE = dynamic(() => import('./CPIvPCE'),
//   { loading: () => <LoadingItem /> })
// const Consumption = dynamic(() => import('./Consumption'),
//   { loading: () => <LoadingItem /> })
// const NonFarmPayroll = dynamic(() => import('./NonFarmPayroll'),
//   { loading: () => <LoadingItem /> })
// const LaborForceParticipation = dynamic(() => import('./LaborForceParticipation'),
//   { loading: () => <LoadingItem /> })
// const UnemploymentRate = dynamic(() => import('./UnemploymentRate'),
//   { loading: () => <LoadingItem /> })
// const RetailSales = dynamic(() => import('./RetailSales'),
//   { loading: () => <LoadingItem /> })
// const SavingsTrend = dynamic(() => import('./SavingsTrend'),
//   { loading: () => <LoadingItem /> })

const RealGDP = dynamic(() => import('./RealGDP'));
const RealGDPGrowth = dynamic(() => import('./RealGDPGrowth'));
const IndustrialProduction = dynamic(() => import('./IndustrialProduction'));
const CurrentInflationMeasures = dynamic(() => import('./CurrentInflationMeasures'));
const HistoricalConsumerPrice = dynamic(() => import('./HistoricalConsumerPrice'));
const CPIvPCE = dynamic(() => import('./CPIvPCE'));
const Consumption = dynamic(() => import('./Consumption'));
const NonFarmPayroll = dynamic(() => import('./NonFarmPayroll'));
const LaborForceParticipation = dynamic(() => import('./LaborForceParticipation'));
const UnemploymentRate = dynamic(() => import('./UnemploymentRate'));
const RetailSales = dynamic(() => import('./RetailSales'));
const SavingsTrend = dynamic(() => import('./SavingsTrend'));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '& .col-md-4:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#fbfbfc',
    // borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(2),
    paddingBottom: 0,
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .option-desc': {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  '& .option-desc .MuiTypography-caption': {
    color: '#333'
  },
  '& .section': {
    minHeight: '3.4rem',
    borderBottom: '1px solid #eae9ee',
    borderColor: '#eae9ee',
    padding: '6px 10px',
    verticalAlign: 'middle',
    background: '#fbfbfc',
    fontSize: '.875rem',
    '& .option-title': {
      fontSize: '.875rem',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      // fontWeight: '700 !important'
      color: '#000000 !important',
    },
    '& button, .share-wrapper': {
      visibility: 'hidden'
    },
  },
  '& .option-desc .MuiTypography-caption': {
    fontSize: '.875rem !important',
  },
  '& .MuiGrid-root': {
    width: '100% !important',
    margin: 0,
  },
  '& .MuiGrid-root > .MuiGrid-item': {
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

const { ECO_SECTION_CODES } = dataConstants || {};

const Summary = ({ data, themes, getChartData, selectedInfo, onChangeInfo, }) => {
  const [snackPack, setSnackPack] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClick = (message) => () => {
    setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  //summary data
  const sumData = {};
  const dataArr = data && data.find(d => d.section_code === ECO_SECTION_CODES.GLA_DATA) ? data.filter(d => d.section_code === ECO_SECTION_CODES.GLA_DATA) : undefined;

  dataArr && dataArr.forEach(d => {
    sumData[d.settings && d.settings.dataSetName ? d.settings.dataSetName : d.section_code] = (d.tabData || []);
  });

  return (
    <NoData noData={!data && !data?.length > 0}>
      <Box component="div" className="eco-sum-section">
        <Item className="row sum-r eco-sum-prod" component="div" sx={{ my: 1 }}>
          <Box className="Item-Head" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.4, px: 0.5, }} >
            <Typography component="h2" className="option-title" sx={{ mr: 'auto' }} >
              {`Production`}
            </Typography>
          </Box>
          {/* <Divider /> */}
          <Box className="ecosec-body" component="div">
            <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <RealGDP
                  data={data}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <RealGDPGrowth
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <IndustrialProduction
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
            </Grid>
          </Box>
        </Item>
        <Item className="row sum-r eco-sum-inflat" component="div" sx={{ my: 1.5 }}>
          <Box className="Item-Head" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.4, px: 0.5, }} >
            <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
              {`Inflation`}
            </Typography>
          </Box>
          {/* <Divider /> */}
          <Box className="ecosec-body" component="div">
            <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <CurrentInflationMeasures
                  data={data}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <HistoricalConsumerPrice
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <CPIvPCE
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
            </Grid>
          </Box >
        </Item >
        <Item className="row sum-r eco-sum-labor" component="div" sx={{ my: 1.5 }}>
          <Box className="Item-Head" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.4, px: 0.5, }} >
            <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
              {`Labour Force`}
            </Typography>
          </Box>
          {/* <Divider /> */}
          <Box className="ecosec-body" component="div">
            <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <UnemploymentRate
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <NonFarmPayroll
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <LaborForceParticipation
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
            </Grid >
          </Box >
        </Item >
        <Item className="row sum-r eco-sum-cons" component="div" sx={{ my: 1.5 }}>
          <Box className="Item-Head" sx={{ display: 'flex', alignItems: 'flex-start', mb: 1.4, px: 0.5, }} >
            <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
              {`Consumer Strength`}
            </Typography>
          </Box>
          {/* <Divider /> */}
          <Box className="ecosec-body" component="div">
            <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <Consumption
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <RetailSales
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                <SavingsTrend
                  data={data}
                  sumData={sumData}
                  onChangeInfo={onChangeInfo}
                  handleClick={handleClick}
                  getChartData={getChartData}
                  selectedInfo={selectedInfo}
                  themes={themes}
                />
              </Grid>
            </Grid >
          </Box>
        </Item>
      </Box>
      <Snackbar
        key={messageInfo ? messageInfo.key : undefined}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionProps={{ onExited: handleExited }}
        message={messageInfo ? messageInfo.message : undefined}
      // action={
      //   <React.Fragment>
      //     <IconButton
      //       aria-label="close"
      //       color="inherit"
      //       sx={{ p: 0.5 }}
      //       onClick={handleClose}
      //     >
      //       <CloseIcon />
      //     </IconButton>
      //   </React.Fragment>
      // }
      />
    </NoData >
  );
};

export default (Summary);

